import { appConfiguration } from '../apps/PrivateApp'

export function getAmountsSaved(
  interestRate: number,
  savedEachMonth: number,
  startAmount: number,
  savingTimeInYears: number,
): {
  totalAmount: number
  accumulatedInterest: number
  accumulatedDeposited: number
} {
  const savingsTimeInMonths = savingTimeInYears * 12
  let amountInTheBank = startAmount
  let accumulatedInterestThisYear = 0
  let accumulatedInterest = 0
  let accumulatedDeposited = 0
  for (let i = 0; i < savingsTimeInMonths; i++) {
    const monthlyInterestRate = interestRate / 12
    const unroundedInterestThisMonth = amountInTheBank * (monthlyInterestRate / 100)
    const roundedUpValue = Math.ceil(unroundedInterestThisMonth * 100) / 100
    accumulatedInterestThisYear += roundedUpValue
    amountInTheBank += savedEachMonth
    accumulatedDeposited += savedEachMonth
    if ((i + 1) % 12 === 0) {
      amountInTheBank += +accumulatedInterestThisYear
      accumulatedInterest += +accumulatedInterestThisYear
      accumulatedInterestThisYear = 0
    }
  }
  const totalAmount = +amountInTheBank.toFixed(0)
  return {
    totalAmount,
    accumulatedInterest: +accumulatedInterest.toFixed(0),
    accumulatedDeposited: +accumulatedDeposited.toFixed(0),
  }
}

export function isFieldValueWithinLimits(field: string, value: number) {
  if (field !== 'startAmount' && field !== 'savedEachMonth' && field !== 'savingTimeInYears')
    return false
  if (value >= appConfiguration[field].minValue && value <= appConfiguration[field].maxValue)
    return true
  return false
}

export function numberToStringWithSpaces(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export function camelToKebab(camelCaseString: string): string {
  return camelCaseString.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()
}
